import { colors } from "../../lib/colors"

export const coefficientColorCheck = (number: number) =>
  number <= 4
    ? colors.prevRoundGray
    : number <= 8
    ? colors.prevRoundGreen
    : number <= 12
    ? colors.prevRoundCarrot
    : number <= 16
    ? colors.prevRoundBlue
    : colors.prevRoundRed
